module.exports = require("@swa-ui/personal-info/src/form/ConfirmEmailFormFields/ConfirmEmailFormFields.module.scss");